import { Divider, HStack, Text, VStack } from '@chakra-ui/react';

import StepCircle from 'app/components/UI/Step/StepCircle';

import { StepProps } from './types';

function Step({ number, name, isActive, isCompleted, isFirstStep, isLastStep }: StepProps) {
  return (
    <VStack w="full" spacing="8px">
      <HStack spacing={0} alignItems="center" w="full">
        <Divider
          w="full"
          opacity={1}
          orientation="horizontal"
          border="1px solid"
          borderColor={isCompleted || isActive ? 'brand.purple' : 'brand.lightGray1'}
          visibility={isFirstStep ? 'hidden' : 'visible'}
        />
        <StepCircle value={number} isActive={isActive} isCompleted={isCompleted} />
        <Divider
          w="full"
          opacity={1}
          orientation="horizontal"
          border="1px solid"
          borderColor={isCompleted ? 'brand.purple' : 'brand.lightGray1'}
          visibility={isLastStep ? 'hidden' : 'visible'}
        />
      </HStack>
      <Text
        color={isActive || isCompleted ? 'brand.purple' : 'brand.darkGray'}
        textStyle="extraSmallMedium"
        textAlign="center"
      >
        {name}
      </Text>
    </VStack>
  );
}

export default Step;
